<template>
    <div class="integration-form">
         <b-card>
            <h2 class="">{{ $t('integration.add_integration') }}</h2>
            <b-form @submit.prevent="onSubmit" enctype="multipart/form-data">
                <!-- for selecting service  -->
                <div class="mb-3 text-left">
                    <label class="mb-1" for="integration_service_id">
                        {{ $t('integration.select_your_integration_service') }}
                    </label>
                        <treeselect
                            :placeholder="$t('integration.select_your_integration_service')"
                            v-model="formFields.integration_service_id"
                            class="form-input"
                            :class="formErrors.has('integration_service_id') ? 'error-input' : ''"
                            :options="serviceOptions"
                            @input="handleServiceChange"
                        ></treeselect>

                    <b-form-invalid-feedback :state="!formErrors.has('integration_service_id')">
                        {{ formErrors.first('integration_service_id') }}
                    </b-form-invalid-feedback>
                </div>
                <div class="mb-3 text-left">
                    <label for="name" class="mb-1">{{
                        $t('integration.organization_name') }}</label>
                    <b-form-input id="name" type="text" v-model="formFields.name"
                        :placeholder="$t('integration.organization_name')"></b-form-input>

                    <b-form-invalid-feedback :state="!formErrors.has('name')">
                        {{ formErrors.first('name') }}
                    </b-form-invalid-feedback> <!-- Show error message -->
                </div>

                <div v-for="(label, key) in dynamicFields" :key="key" class="mb-3 text-left">
                    <label :for="label" class="mb-1">
                        {{ $t(`integration.${label}`) }}
                    </label>
                    <b-input-group
                        v-if="label !== 'google_service_account_credentials_json' && label !== 'product_service'">
                        <b-form-input :id="String(label)" v-model="formFields[label]"
                            :type="passwordVisibility[label] ? 'text' : 'password'"
                            :placeholder="$t(`integration.${label}`)"></b-form-input>
                        <b-input-group-append>
                            <b-button @click="toggleVisibility(label)" variant="light">
                                <b-icon :icon="passwordVisibility[label] ? 'eye-slash' : 'eye'"></b-icon>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>


                     <treeselect
                            v-else-if="label === 'product_service'"
                            :placeholder="$t(`integration.${label}`, { defaultValue: label })"
                            v-model="formFields[label]"
                            class="form-input"
                            :options="productsServicesOptions"
                        ></treeselect>
                    <b-form-file v-else :id="String(label)"
                        v-model="formFields.google_service_account_credentials_json"
                        :placeholder="$t(`integration.${label}`)"></b-form-file>


                    <b-form-invalid-feedback :state="!formErrors.has(label)">
                        {{ formErrors.first(label) }}
                    </b-form-invalid-feedback>
                </div>


                <!-- status  -->
                <div class="mb-3 text-left">
                    <label for="status" class="mb-1" :class="statusState">
                        {{ $t('integration.select_status') }}
                    </label>
                    <treeselect
                            :placeholder="$t('integration.select_status')"
                            v-model="formFields.is_active"
                            class="form-input"
                            :class="formErrors.has('is_active') ? 'error-input' : ''"
                            :options="statusOptions"
                            @input="removeError('is_active')"
                        ></treeselect>

                    <b-form-invalid-feedback :state="!formErrors.has('is_active')">
                        {{ formErrors.first('is_active') }}
                    </b-form-invalid-feedback>
                </div>
                <div class="mb-3 text-left">
                    <label for="limit" class="mb-1" :class="statusLimit">
                        {{ $t('integration.select_limit') }}
                    </label>
                    <b-form-datepicker id="date_picker" v-model="formFields.selected_date" reset-button
                        today-button locale="en" class="w-100">
                    </b-form-datepicker>
                    <b-form-invalid-feedback :state="!formErrors.has('limit')">
                        {{ formErrors.first('limit') }}
                    </b-form-invalid-feedback>
                </div>

                <div class="d-flex gap-2 mt-4">
                <b-button
                    type="submit"
                    variant="primary"
                    :disabled="isSubmitting"
                >
                    <b-spinner small v-if="isSubmitting" class="mr-1"></b-spinner>
                    {{$t('action.submit')}}
                </b-button>
                <b-button variant="secondary" @click="cancel">{{$t('action.cancel')}}</b-button>
            </div>
            </b-form>
        </b-card>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { reactive } from 'vue';
import { request } from "@/Util/Request";
import Error from "@/Util/Error";
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
// import InputChangeConfirmationModal from "../modal/InputChangeConfirmationModal";


const FORM_STATE = {
    name: '',
    selected_date: '',
    integration_service_id: null,
    is_active: null
};

export default {
    name: "IntegrationCreate",
    data() {
        return {
            formFields: { ...FORM_STATE },
            formErrors: new Error({}),
            serviceOptions: [],
            statusOptions: [
                { label: this.$t('integration.active'), id: '1' },
                { label: this.$t('integration.inactive'), id: '0' },
            ],
            dynamicFields: {},
            selectedService: null,
            allProductServicesOptions: {
                salesforce: [
                    { label: this.$t('integration.crm'), id: 'CRM' },
                    { label: this.$t('integration.analytics'), id: 'Analytics' },
                    { label: this.$t('integration.net_zero_cloud'), id: 'Net Zero Cloud' },
                    { label: this.$t('integration.financial_services_cloud'), id: 'Financial Services Cloud' },
                    { label: this.$t('integration.communications_cloud'), id: 'Communications Cloud' },
                    { label: this.$t('integration.education_cloud'), id: 'Education Cloud' },
                ],
                zoho: [
                    { label: this.$t('integration.crm'), id: 'CRM' },
                ],
            },
            defaultDate: new Date(),
            passwordVisibility: {},
            originalForm: {},
            isFormDirty: false,
            nextRoute: '',
            isSubmitting: false
        };
    },
    components: {Treeselect },
    computed: {
        ...mapGetters(['loader']),
        productsServicesOptions() {
            const selectedServiceName = this.selectedService.label.toLowerCase();
            if (selectedServiceName.includes('salesforce')) {
                return this.allProductServicesOptions.salesforce;
            } else if (selectedServiceName.includes('zoho')) {
                return this.allProductServicesOptions.zoho;
            }
            return [];
        },
        nameState() {
            return this.formFields.name === '' ? '' : this.formErrors.$errors.name ? 'is-invalid' : 'is-valid';
        },
        statusState() {
            return this.formFields.status === null ? '' : this.formErrors.status ? 'is-invalid' : 'is-valid'; // Add computed for status
        },
        statusLimit() {
            return this.formFields.limit === null ? '' : this.formErrors.limit ? 'is-invalid' : 'is-valid'; // Add computed for status
        }
    },

    methods: {
        async removeError(key) {
            if (typeof key === 'object') {
                for (let i = 0; i < key.length; i++) {
                    this.formErrors.remove(key[i]);
                }
            } else {
                this.formErrors.remove(key);
            }
        },
        cancel() {
            this.$router.back();
        },
        goBackToDestination() {
            if(this.nextRoute) {
                this.$router.push(this.nextRoute);
            }
        },
        handleNavigation(crumb) {
            if (this.isFormDirty) {
                this.$refs['inputChangeConfirmationModal'].handleToggleModal();
                this.nextRoute = crumb.path; // Store next route
            } else {
                this.$router.push(crumb.path); // Navigate if no unsaved changes
            }
        },
        markAsDirty() {
            this.isFormDirty = true;
        },
        checkForChanges() {
            this.isFormDirty = JSON.stringify(this.formFields) !== JSON.stringify(this.originalForm);
        },
        resetForm() {
            this.formFields = reactive({
                name: '',
                selected_date: null,
                // typeSelect: { value: '', label: this.$t('integration.Please_select_your_service') },
                status: { value: '1', label: this.$t('integration.Active') },
            });
        },
        initializeVisibility() {
            Object.keys(this.formFields).forEach((key) => {
                if (!(key in this.passwordVisibility)) {
                    this.$set(this.passwordVisibility, key, false);
                }
            });
        },
        toggleVisibility(field) {
            this.passwordVisibility[field] = !this.passwordVisibility[field];
        },
        async fetchServices() {
            try {
                const response = await request({ method: 'get', url: `/admin/services` });

                this.serviceOptions = response.data.map(service => ({
                    id: service.id,
                    label: service.name,
                    fields: service.fields || {}
                }));

            } catch (error) {
                console.error('Error fetching services:', error);
            }
        },



        handleServiceChange(serviceId) {
            const selectedService = this.serviceOptions.find(service => service.id === serviceId);
            this.dynamicFields = selectedService?.fields || {};
            this.selectedService = selectedService;
        },


        // Validate the Service Selection

        validateStatus() {
            const status = this.formFields.status;
            if (!status) {
                this.formErrors.$errors.status = [this.$t('integration.statusRequired')]; // Add custom error for status
            } else {
                delete this.formErrors.$errors.status;
            }
        },
        reloadPage() {
            window.location.reload();
        },

        async onSubmit() {
            let formData = new FormData();
            // Manually construct the payload, including all dynamic fields
            formData.append("name", this.formFields.name || "");
            formData.append("is_active", this.formFields.status === "InActive" ? 0 : 1);
            formData.append("limit", this.formFields.selected_date || "");

            // Loop through the dynamic fields and add them to the FormData
            Object.keys(this.formFields).forEach((key) => {
                if (key !== "status" && key !== "typeSelect" && key !== "product_service") {
                    if (key === "google_service_account_credentials_json" && this.formFields[key]) {
                        // Append file instead of converting it to JSON
                        formData.append(key, this.formFields[key]);
                    } else {
                        formData.append(key, this.formFields[key] || "");
                    }
                }
            });

            if (this.formFields.product_service) {
                formData.append("product_service", this.formFields.product_service);
            }

            // Make the API call
            try {
                const response = await request({
                    method: "post",
                    url: "/admin/integrations",
                    data: formData,
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });

                // Handle success response
                if (response["message"] && response["message"].includes("successfully")) {
                    this.showToast();
                    setTimeout(() => {
                        this.$router.push({ name: "Integrations" });
                    }, 1000);
                } else {
                    throw new Error(response.message || "Error submitting form");
                }
           } catch (error) {
                if (error.request && error.request.status && error.request.status === 422) {
                    this.formErrors = new Error(JSON.parse(error.request.responseText).errors);
                    return false;
                } else {
                    this.notifyError();
                }
            }
        },



        showToast() {
            const h = this.$createElement;
            const vNodesMsg = h('p', { class: ['text-center', 'mb-0'] }, [
                this.$t('integration.dataSaved')
            ]);
            // Create the title
            const vNodesTitle = h(
                'div',
                { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] },
                [h('strong', { class: 'mr-2' }, this.$t('integration.dataSavedTitle'))]
            );
            // Pass the VNodes as an array for message and title
            this.$bvToast.toast([vNodesMsg], {
                title: [vNodesTitle],
                solid: true,
                variant: 'success',
            });
        },

        onCancel() {
            this.$router.push({ name: 'Integrations' });
        },
    },
    watch: {
        formFields: {
            deep: true,
            handler() {
                this.initializeVisibility(); // Ensure visibility state is updated when new fields are added
                this.checkForChanges();
            }
        }
    },
    created() {
        this.fetchServices(); // Fetch services when component loads
        this.initializeVisibility();
        this.originalForm = { ...this.formFields };
    },
};
</script>

<style scoped>
.integration-form {
  padding: 20px;
}

.form-group {
    margin-bottom: 20px;
}

h2 {
    margin-bottom: 1.5rem;
    color: #2c3e50;
    font-size: 2rem;
}

.error-input {
    border-color: #dc3545 !important;
}
</style>
